import { Dispatch, SetStateAction, useEffect } from 'react';
import { Button, Grid, Modal, Segment, TextArea } from 'semantic-ui-react';

function ScanModal({
  open,
  setOpen,
  submitHandler,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  submitHandler: () => void;
}) {
  useEffect(() => {
    var input = document.getElementById(
      'myInputQuickscan',
    ) as HTMLTextAreaElement;
    // Execute a function when the user presses a key on the keyboard
    input?.addEventListener('keypress', function (event: any) {
      // If the user presses the "Enter" key on the keyboard
      if (event.key === 'Enter') {
        // Cancel the default action, if needed
        // event.preventDefault();
        // setScannedBarcode(p => [...p, event?.target?.value]);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      }
    });
  }, []);

  return (
    <Modal open={open}>
      <Modal.Header>Scan Asset</Modal.Header>
      <Segment placeholder>
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column width={16}>
              <TextArea
                rows={14}
                id="myInputQuickscan"
                autoFocus={true}
                open={open}
                style={{
                  height: '100%',
                  width: '100%',
                  maxWidth: '70rem',
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
      <Modal.Actions>
        <Button color="black" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          content="Submit"
          labelPosition="right"
          icon="checkmark"
          onClick={submitHandler}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}
export default ScanModal;
